(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  const announcementBarSlider = new Swiper('.announcement-bar', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('input', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !window.DesignMode) return;
  try {
    
  const announcementBarSlider = new Swiper('.product__list-container', {
    slidesPerView: "auto",
    loop: false,
    spaceBetween: 26,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "fraction",
    }, navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
if(document.querySelector('.js-open-search')){
  const openSearch = document.querySelector('.js-open-search');
  const closeSearch = document.querySelector('.js-close-search');
  const search = document.querySelector('.header__search');

  openSearch.addEventListener('click', () => {
    if (search.classList.contains('is-visible')) {
      search.classList.remove('is-visible');
    } else {
      search.classList.add('is-visible');
    }
  });

  closeSearch.addEventListener('click', () => {
    search.classList.remove('is-visible');
  }); 
  
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-send-fs-candies"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product__media-list-mobile', {
    slidesPerView: 1,
    freeMode: true,
    loop: false,
    spaceBetween: 8,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },    
    breakpoints: {
      768: {
        slidesPerView: 1.7,
        freeMode: true,
        loop: false,
        spaceBetween: 8,
      }
    }
  });

  // Gift product slider
  const productSlidernew = new Swiper('.gift__product--slider', {
    slidesPerView: 2.5,
    freeMode: true,
    loop: false,
    spaceBetween: 18,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },    
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        freeMode: true,
        loop: false,
        spaceBetween: 18,
      },
      1022: {
        slidesPerView: 3.5,
        freeMode: true,
        loop: false,
        spaceBetween: 18,
      }
    }
  });

    // vase product slider
  // const productSliderVase = new Swiper('.vase__product--slider', {
  //   slidesPerView: 2.5,
  //   freeMode: true,
  //   loop: false,
  //   spaceBetween: 18,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },    
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 2.5,
  //       freeMode: true,
  //       loop: false,
  //       spaceBetween: 18,
  //     },
  //     1022: {
  //       slidesPerView: 3.5,
  //       freeMode: true,
  //       loop: false,
  //       spaceBetween: 18,
  //     }
  //   }
  // });

  window.addEventListener("load", function(event) {
    let varWidth = document.getElementById("gift__product--slider").offsetWidth;
    document.getElementById('variable-vase').style.width=`${varWidth}px`;
  });

  window.addEventListener('resize', function(event){
    let varWidth = document.getElementById("gift__product--slider").offsetWidth;
    document.getElementById('variable-vase').style.width=`${varWidth}px`;
  });


  document.addEventListener('DOMContentLoaded', function () {


        let upsellArray = [];
        let candyVariantIds = window.candyVariantIds;
        let customValidation = window.customValidation();
        let errorMsgValidation = document.querySelector(".error-msg-validation");
        if(customValidation){
          if(errorMsgValidation){
            errorMsgValidation.textContent = customValidation;
          }
        }else{
          candyVariantIds.forEach(id => {
            let idExists = upsellArray?.some(product => product.id === id);
            if(!idExists){
              let obj = {
                'id': id,
                'quantity': 1
              }
              upsellArray.push(obj)
            }
            window.specificUpsellData = upsellArray;
          });
        }


    
  });



  
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-send-fs"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product__media-list-mobile', {
    slidesPerView: 1,
    freeMode: true,
    loop: false,
    spaceBetween: 8,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },    
    breakpoints: {
      768: {
        slidesPerView: 1.7,
        freeMode: true,
        loop: false,
        spaceBetween: 8,
      }
    }
  });

  // Gift product slider
  const productSlidernew = new Swiper('.gift__product--slider', {
    slidesPerView: 2.5,
    freeMode: true,
    loop: false,
    spaceBetween: 18,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },    
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        freeMode: true,
        loop: false,
        spaceBetween: 18,
      },
      1022: {
        slidesPerView: 3.5,
        freeMode: true,
        loop: false,
        spaceBetween: 18,
      }
    }
  });

    // vase product slider
  // const productSliderVase = new Swiper('.vase__product--slider', {
  //   slidesPerView: 2.5,
  //   freeMode: true,
  //   loop: false,
  //   spaceBetween: 18,
  //   navigation: {
  //     nextEl: '.swiper-button-next',
  //     prevEl: '.swiper-button-prev',
  //   },    
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 2.5,
  //       freeMode: true,
  //       loop: false,
  //       spaceBetween: 18,
  //     },
  //     1022: {
  //       slidesPerView: 3.5,
  //       freeMode: true,
  //       loop: false,
  //       spaceBetween: 18,
  //     }
  //   }
  // });

  window.addEventListener("load", function(event) {
    let varWidth = document.getElementById("gift__product--slider").offsetWidth;
    document.getElementById('variable-vase').style.width=`${varWidth}px`;
  });

  window.addEventListener('resize', function(event){
    let varWidth = document.getElementById("gift__product--slider").offsetWidth;
    document.getElementById('variable-vase').style.width=`${varWidth}px`;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1.7,
    freeMode: true,
    loop: false,
    spaceBetween: 8,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },    
    breakpoints: {
      768: {
        slidesPerView: 1.7,
        freeMode: true,
        loop: false,
        spaceBetween: 8,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-subscription-product"]) return;
  try {
    
  // Main product slider
  const productSlider = new Swiper('.product__media-list', {
    slidesPerView: 1.7,
    freeMode: true,
    loop: false,
    spaceBetween: 8,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },    
    breakpoints: {
      768: {
        slidesPerView: 1.7,
        freeMode: true,
        loop: false,
        spaceBetween: 8,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
      var tabs = document.querySelectorAll(".product__tabs--main ul.tabs li");
      tabs.forEach(function (tab) {
        tab.addEventListener("click", function () {
          var tab_id = tab.getAttribute("data-tab");
          if (!tab.classList.contains("current")) {
              tabs.forEach(function (t) {
                  t.classList.remove("current");
              });
              var tabContents = document.querySelectorAll(".product__tabs--content .tab-content");
              tabContents.forEach(function (content) {
                  content.classList.remove("current");
              });
              tab.classList.add("current");
              const currentTabId = document.getElementById(tab_id);
              if(currentTabId){
                currentTabId.classList.add("current");
              }
              const urlWithoutQuery = window.location.origin + window.location.pathname;
              history.replaceState(null, null, urlWithoutQuery);
          }
        });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-image-section-slider"] && !window.DesignMode) return;
  try {
    
  const columnSlider = new Swiper('.full__image-slider', {
     slidesPerView: 1,
     loop: true,
     autoplay: {
        delay: 2000
     },
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-image-slider"] && !window.DesignMode) return;
  try {
    
  const columnSlider = new Swiper('.two__image-slider', {
     slidesPerView: 2,
     loop: true,
     autoplay: {
        delay: 2000
     },
  });

  } catch(e) { console.error(e); }
})();
})();
